import React, { Component } from 'react';
import { withAlert } from 'react-alert';
import { Button } from 'reactstrap';
import Api from '../Api';
import CrudForm from '../Crud/Form';
import Exports from '../Exports';
export default withAlert()(class ExportTable extends Component {
  constructor(props) {
    super(props);
    this.updateState = data => this.setState(data);
    this.toggleExport = () => this.setState(prevState => ({
      exportOpen: !prevState.exportOpen
    }));
    this.exportBtn = () => /*#__PURE__*/React.createElement("div", {
      className: "text-right"
    }, /*#__PURE__*/React.createElement(Button, {
      outline: true,
      color: "success",
      onClick: this.exportOrder,
      disabled: this.state.disabled
    }, /*#__PURE__*/React.createElement("small", null, "Export Grain Ticket")));
    this.exportOrder = () => {
      const params = {
        grain_ticket_export: 'Y',
        id: this.props.modelUuid,
        type: this.props.modelType
      };
      this.setState({
        disabled: true
      });
      Api.crudCreate(this.props.auth, 'exports', params).then(response => response !== undefined ? this.succesResponse() : this.errorResponse());
    };
    this.succesResponse = () => {
      this.props.alert.show('Agris Export successfully queued', {
        type: 'success'
      });
      this.setState({
        exportLoading: true
      });
      Exports.getData(this.options(), this.updateState);
    };
    this.errorResponse = () => {
      const errorMessage = 'System error, please try again. If you continue to get this error, open a Help Desk ticket';
      this.props.alert.show(errorMessage, {
        type: 'error'
      });
      this.setState({
        disabled: false
      });
    };
    this.titleRight = () => this.props.showExportButton === true ? this.exportBtn() : null;
    this.options = () => {
      const state = this.state;
      const storageName = "otto_".concat(this.props.modelUuid, "_exports");
      return {
        storageName,
        auth: this.props.auth,
        type: this.props.modelType,
        uuid: this.props.modelUuid,
        data: state.exportData || [],
        open: state.exportOpen,
        pages: state.exportPages,
        loading: state.exportLoading,
        tableRef: state.exportTableRef,
        toggle: this.toggleExport,
        hideBottomHr: true,
        titleRight: this.titleRight()
      };
    };
    this.render = () => Exports.getTable(this.updateState, this.options());
    this.state = {
      disabled: false,
      exportOpen: true,
      exportLoading: true,
      exportTableRef: React.createRef()
    };
  }
});